<template>
  <v-layout column fill-height>
    <v-flex class="header" shrink>
      <navigation fixed />
    </v-flex>
    <v-flex class="main has-fixed-header" :class="{ 'has-cookie': (pageFrom !== 'store') && showCookie && !isTheme1 && !storeInfo.agent, 'is-from-page': pageFrom === 'store' }">
      <router-view />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

import Navigation from "../common/navigation";

export default {
  components: {
    Navigation
  },
  computed: {
    ...mapState(["showCookie", "pageFrom", "isTheme1", "storeInfo"])
  }
};
</script>

<style scoped lang="sass" src="./basic-layout.sass"></style>
